import { render, staticRenderFns } from "./mailingList.vue?vue&type=template&id=03074882&"
import script from "./mailingList.vue?vue&type=script&lang=js&"
export * from "./mailingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports